export default __webpack_public_path__ + "static/media/money.d970122b.png";